/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import theme from 'env/theme'
import { makeStyles } from '@material-ui/styles'
import Tooltip from '@material-ui/core/Tooltip'
import Domino from './Domino'
import {
  HANDICAP_TYPE,
  ACCESSIBILITY_LEVEL,
} from '../../domains/cards/enums/handicaps'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    width: theme.spacing(5),
    height: theme.spacing(5),
  },
})

const generateTooltip = (handicap, value) => {
  const textTooltip = HANDICAP_TYPE[handicap] || ''
  const textAccessibilityLevel = ACCESSIBILITY_LEVEL[value] || ''

  return (
    <>
      {textTooltip}
      <br />
      <b>{textAccessibilityLevel}</b>
    </>
  )
}

const generateDominoAriaLabel = (handicap, value) => {
  const textAriaLabel = HANDICAP_TYPE[handicap] || ''
  const textAccessibilityLevel = ACCESSIBILITY_LEVEL[value] || ''

  return `${textAccessibilityLevel} pour une ${textAriaLabel}`
}

const HandicapsIcon = (props) => {
  const { value, slug } = props
  const classes = useStyles()

  return (
    <Tooltip
      title={`${HANDICAP_TYPE[slug] || ''} - ${
        ACCESSIBILITY_LEVEL[value] || ''
      }`}
    >
      <div className={classes.root}>
        <Domino
          tabIndex="0"
          tooltip={generateTooltip(slug, value)}
          ariaLabel={generateDominoAriaLabel(slug, value)}
          placement="left"
          handicap={slug}
          value={value}
        />
      </div>
    </Tooltip>
  )
}

export default HandicapsIcon
